import { SxProps } from '@mui/material'

interface AccordionSummaryStyles {
  accordionSummaryIconStyles: SxProps
}

export const accordionSummaryStyles: AccordionSummaryStyles = {
  accordionSummaryIconStyles: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      minWidth: 40,
      height: 40,
      backgroundColor: 'primary.smokyBlack',
      borderRadius: 3,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 1.25,
      color: 'button.backgroundSecondary',
    },

    '.plusIcon': { display: 'block' },
    '.minusIcon': { display: 'none' },

    '&.Mui-expanded': {
      '.plusIcon': { display: 'none' },
      '.minusIcon': { display: 'block' },
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
      marginTop: 1.5,
    },
    '&.MuiAccordionSummary-root': {
      alignItems: 'start',
    },
  },
}
